import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import apiService from '../../services/apiService';

const COLUMNS = [
    { id: 'TODO', title: 'To Do', color: '#cbd5e1' },
    { id: 'IN_PROGRESS', title: 'In Progress', color: '#60a5fa' },
    { id: 'REVIEW', title: 'In Review', color: '#fcd34d' },
    { id: 'DONE', title: 'Done', color: '#34d399' }
];

const AITaskBoardTab = ({ activeTab }) => {
    const [tasks, setTasks] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (activeTab === 'taskboard') {
            fetchTasks();
        }
    }, [activeTab]);

    const fetchTasks = async () => {
        setLoading(true);
        try {
            const data = await apiService.makeRequest('/admin/katifi/tasks');
            setTasks(data);
        } catch (error) {
            console.error(error);
            toast.error("Failed to load Task Board");
        } finally {
            setLoading(false);
        }
    };

    const handleStatusChange = async (taskId, newStatus) => {
        try {
            await apiService.makeRequest(`/admin/katifi/tasks/${taskId}/status`, {
                method: 'PUT',
                body: JSON.stringify({ status: newStatus })
            });
            toast.success("Task updated");
            fetchTasks(); // Refresh board
        } catch (e) {
            toast.error("Failed to move task");
        }
    };

    if (activeTab !== 'taskboard') return null;

    // Group Tasks
    const groupedTasks = {
        TODO: tasks.filter(t => t.status === 'TODO'),
        IN_PROGRESS: tasks.filter(t => t.status === 'IN_PROGRESS'),
        REVIEW: tasks.filter(t => t.status === 'REVIEW'),
        DONE: tasks.filter(t => t.status === 'DONE')
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
            <div style={{ background: '#fff', padding: '30px', borderRadius: '16px', border: '1px solid #E5E1D6', boxShadow: '0 4px 20px -2px rgba(32, 35, 31, 0.04)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                    <div>
                        <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#20231F', marginBottom: '6px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <span style={{ fontSize: '26px' }}>📋</span> AI Agency Kanban Board
                        </h2>
                        <p style={{ color: '#5C645A', fontSize: '14px', margin: 0 }}>Track and manage active assignments delegated to your AI Employees.</p>
                    </div>
                    <button onClick={fetchTasks} style={{ padding: '8px 16px', borderRadius: '8px', background: '#FAF4E5', color: '#A97F2E', border: '1px solid #E5E1D6', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}>
                        🔄 Refresh Board
                    </button>
                </div>

                {loading ? <p>Loading the board...</p> : (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px', minHeight: '500px' }}>
                        {COLUMNS.map(col => (
                            <div key={col.id} style={{ background: '#FBFBFA', borderRadius: '14px', padding: '18px', border: '1px solid #E5E1D6' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '15px', paddingBottom: '10px', borderBottom: '2px solid', borderBottomColor: col.color }}>
                                    <h3 style={{ margin: 0, fontSize: '15px', fontWeight: 'bold', color: '#1e293b' }}>{col.title}</h3>
                                    <span style={{ background: '#e2e8f0', color: '#475569', padding: '2px 8px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold' }}>
                                        {groupedTasks[col.id]?.length || 0}
                                    </span>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    {groupedTasks[col.id]?.map(task => (
                                        <div key={task.id} style={{ background: '#FFFFFF', borderRadius: '12px', padding: '16px', border: '1px solid #E5E1D6', boxShadow: '0 2px 6px rgba(32,35,31,0.03)', cursor: 'grab' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                                                <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#A97F2E', textTransform: 'uppercase', background: '#FAF4E5', padding: '2px 8px', borderRadius: '6px', border: '1px solid #F3E8C9' }}>
                                                    {task.agent_name}
                                                </span>
                                                <span style={{ fontSize: '10px', color: '#94a3b8' }}>#{task.id}</span>
                                            </div>
                                            <h4 style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#0f172a', fontWeight: '600', lineHeight: '1.4' }}>
                                                {task.title}
                                            </h4>
                                            {task.description && (
                                                <p style={{ margin: '0 0 15px 0', fontSize: '12px', color: '#64748b', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                                    {task.description}
                                                </p>
                                            )}
                                            
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #f1f5f9', paddingTop: '10px' }}>
                                                <span style={{ fontSize: '11px', color: '#94a3b8' }}>Move to:</span>
                                                <select 
                                                    value={task.status} 
                                                    onChange={(e) => handleStatusChange(task.id, e.target.value)}
                                                    style={{ border: 'none', background: '#f8fafc', color: '#475569', fontSize: '12px', fontWeight: 'bold', outline: 'none', cursor: 'pointer' }}
                                                >
                                                    {COLUMNS.map(c => (
                                                        <option key={c.id} value={c.id}>{c.title}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    ))}
                                    {(!groupedTasks[col.id] || groupedTasks[col.id].length === 0) && (
                                        <div style={{ textAlign: 'center', padding: '20px', color: '#cbd5e1', fontSize: '13px' }}>
                                            No tasks here
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default AITaskBoardTab;
